// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"QX-z","sponsoredTooltipWrapper":"RX-z","sponsoredTooltip":"SX-z","newCard":"TX-z"};